import { Component, OnInit } from '@angular/core';
import { ConfigurazioneGeneraleService } from '../../services/configurazione-generale.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AmministrazioneService } from '../../services/amministrazione.service';
import { PnFunzioneServizio } from '../../models/servizio';
import { SubscriptionManager } from '../../shared/subscription-manager/subscription-manager.class';

@Component({
  selector: 'jhi-informativa-privacy',
  templateUrl: './informativa-privacy.component.html',
  styleUrls: ['./informativa-privacy.component.scss']
})
export class InformativaPrivacyComponent extends SubscriptionManager implements OnInit {
  loading = false;
  servizio = '';
  funzioneServizio?: PnFunzioneServizio;
  isChecked = false;

  constructor(protected configurazioneGeneraleService: ConfigurazioneGeneraleService, private router: Router, private ammService: AmministrazioneService, private activatedRoute: ActivatedRoute) {
    super();
  }

  ngOnInit(): void {
    this.servizio = <string>this.activatedRoute.snapshot.queryParams['servizio'];
    this.subs.sink = this.ammService.pnFunzioneServizioByCdFunzione(this.servizio).subscribe({
      next: (res) => {
        this.funzioneServizio = res;
      }
    })
  }

  goToServizi():void{
    window.location.href = this.configurazioneGeneraleService.configurazione.linkServizi;
  }

  goToHome():void{
    window.location.href = this.configurazioneGeneraleService.configurazione.linkHome;
  }

  goToInformativa():void{
    window.location.href = this.configurazioneGeneraleService.configurazione.linkPrivacy;
  }

  goToIstanza():void{
    this.router.navigateByUrl("/Servizi/NuovaIstanza?servizio=" + this.servizio);
  }

}
